/**
 * The statuses the desktop views file under "Queued".
 *
 * 🔑 The server owns which statuses its /jobs/queued page returns — CREATED and QUOTED
 * today — and every view draws its queued jobs from that page alone. This list exists
 * for the OTHER side of the same rule: a job in one of these statuses must never be
 * drawn from the month payload, or it appears twice. APPROVED is kept because the
 * views have always listed it; the server has no such status and it never occurs.
 */
export const QUEUED_COLUMN_STATUSES = ['CREATED', 'QUOTED', 'APPROVED'];

/** True for a job the month payload must not draw — it belongs to the queued page. */
export const isQueuedStatus = (status) => QUEUED_COLUMN_STATUSES.includes(status);

export default QUEUED_COLUMN_STATUSES;
